<script setup lang="ts">
import CustomButton from '@/components/CustomButton.vue';
import UpsertSourceDialog from '@/components/dialogs/UpsertSourceDialog.vue';
import List from '@/components/List.vue';
import { useGlobalStore } from '@/stores/global';
import { useSourceStore } from '@/stores/source';
import type { Source } from '@/types/source';
import { onMounted, ref } from 'vue';

const sourceStore = useSourceStore();

const globalStore = useGlobalStore();
const isUpsertDialogOpen = ref(false);
const selectedSource = ref<Source | null>(null);

const listHeaders = [{ title: 'Naam', value: 'name', sortable: true }];

onMounted(async () => {
    await sourceStore.getGlobalSources();
});

async function deleteGlobalSource(item: Source) {
    await sourceStore.remove(item._id);
}

function openUpsertDialog(item: Source) {
    selectedSource.value = item;
    isUpsertDialogOpen.value = true;
}
</script>

<template>
    <v-fade-transition>
        <div v-show="!globalStore.isLoading">
            <v-row>
                <CustomButton text="Globale bron toevoegen" @click="isUpsertDialogOpen = true" />
            </v-row>
            <List
                v-if="sourceStore.globalSources.length > 0"
                :items="sourceStore.globalSources"
                :headers="listHeaders"
                showSearch
                entityName="Bron"
                :items-per-page="50"
                @delete-confirmed="deleteGlobalSource"
                is-deletable
                @click-table-row-edit="openUpsertDialog"
                is-editable
            />
            <p v-else>Geen bronnen gevonden</p>

            <UpsertSourceDialog :modelValue="isUpsertDialogOpen" :source="selectedSource" @closeDialog="isUpsertDialogOpen = false" />
        </div>
    </v-fade-transition>
</template>

<style scoped></style>
